import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {

  const handleAboutClick = () => {
    // Scroll to the top of the page
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  const [stickyMenu, setStickyMenu] = useState(false);
  const [navigationOpen, setNavigationOpen] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [page] = useState('Home');

  const handleScroll = () => {
    setStickyMenu(window.scrollY > 0);
  };

  const handleHamburgerToggle = () => {
    setNavigationOpen(!navigationOpen);
  };

  const handleDropdownToggle = () => {
    setDropdown(!dropdown);
  };

  React.useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header className={`fixed left-0 top-0 w-full z-9999 py-7 lg:py-0 'bg-dark/70  !py-4 lg:!py-0 transition duration-100 before:absolute before:w-full before:h-[1px] before:bottom-0 before:left-0 before:features-row-border' : ''}`}>
      <div className="max-w-[1170px] mx-auto px-4 sm:px-8 xl:px-0 lg:flex items-center justify-between relative">
        <div className="w-full lg:w-1/3 flex items-center justify-between">
          <Link to="/">
            <img src={require('../images/logo/logo.svg').default} alt="Logo"  />
          </Link>
          <button className="lg:hidden block" onClick={handleHamburgerToggle}>
            {/* Hamburger Icon JSX */}
          </button>
        </div>

        <div className={`w-full lg:w-3/4 h-0 lg:h-auto ${navigationOpen ? 'visible bg-dark shadow-lgrelative !h-auto max-h-[400px] overflow-y-scroll rounded-md mt-4 p-7.5' : 'invisible lg:visible lg:flex items-center justify-between'}`}>
          <nav>
            <ul className="flex lg:items-center flex-col lg:flex-row gap-5 lg:gap-2">
              <li className={`nav__menu lg:py-7 ${!stickyMenu ? 'lg:!py-4' : ''}`}>
                <a href="/#home" className={`relative text-white/80 text-sm py-1.5 px-4 border border-transparent hover:text-white hover:nav-gradient ${!stickyMenu ? '' : '!text-white nav-gradient'}`}>Home</a>
              </li>
              <li className={`nav__menu lg:py-7 ${!stickyMenu ? 'lg:!py-4' : ''}`}>
                <a href="/#features" className="relative text-white/80 text-sm py-1.5 px-4 border border-transparent hover:text-white hover:nav-gradient">Features</a>
              </li>
              <li className={`nav__menu lg:py-7 ${!stickyMenu ? 'lg:!py-4' : ''}`}>
                <a href="/#pricing" className="relative text-white/80 text-sm py-1.5 px-4 border border-transparent hover:text-white hover:nav-gradient">Pricing</a>
              </li>
              <li className={`group relative lg:py-7 ${!stickyMenu ? 'lg:!py-4' : ''}`} onClick={handleDropdownToggle}>
                {/* <a href="#" className={`relative text-white/80 text-sm py-1.5 px-4 border border-transparent hover:text-white hover:nav-gradient flex items-center justify-between gap-3 ${page === 'about' || page === 'pricing' || page === 'blog-grid' || page === 'blog-single' || page === 'signin' || page === 'signup' || page === '404' ? '!text-white nav-gradient' : ''}`}>
                  
                  <svg className="fill-current w-3 h-3 cursor-pointer" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z" />
                  </svg>
                </a> */}
                <ul className={''}>
                  {/* <li>
                  <Link to="/about" className={`flex text-sm text-white/70 hover:text-white py-2 px-4 rounded-md hover:bg-white/5 ${page === 'about' ? '!text-white bg-white/5' : ''}`}>About Us</Link>
                  </li> */}
                  {/* <li>
                    <a href="Pricing.jsx" className={`flex text-sm text-white/70 hover:text-white py-2 px-4 rounded-md hover:bg-white/5 ${page === 'pricing' ? '!text-white bg-white/5' : ''}`}>Pricing Table</a>
                  </li> */}
                  {/* ... other dropdown items */}
                </ul>
              </li>
              <li className={`nav__menu lg:py-7 ${!stickyMenu ? 'lg:!py-4' : ''}`}>
                <a href="/#support" className="relative text-white/80 text-sm py-1.5 px-4 border border-transparent hover:text-white hover:nav-gradient">Support</a>
              </li>
              <ul className={`nav__menu lg:py-7 ${!stickyMenu ? 'lg:!py-4' : ''}`}>
              <Link to="/about" onClick={handleAboutClick} className="relative text-white/80 text-sm py-1.5 px-4 border border-transparent hover:text-white hover:nav-gradient">About</Link>
              </ul>
            </ul>
          </nav>

          <div className="flex items-center gap-6 mt-7 lg:mt-0">
            <Link to="/waitlist" className="button-border-gradient relative rounded-lg text-white text-sm flex items-center gap-1.5 py-2 px-4.5 shadow-button hover:button-gradient-hover hover:shadow-none">Become a Intellevo Member</Link>
            {/* <Link to="/signup" className="button-border-gradient relative rounded-lg text-white text-sm flex items-center gap-1.5 py-2 px-4.5 shadow-button hover:button-gradient-hover hover:shadow-none">
              Get Started
              <svg className="mt-0.5" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.4002 7.60002L9.2252 2.35002C9.0002 2.12502 8.6502 2.12502 8.4252 2.35002C8.2002 2.57502 8.2002 2.92502 8.4252 3.15002L12.6252 7.42502H2.0002C1.7002 7.42502 1.4502 7.67502 1.4502 7.97502C1.4502 8.27502 1.7002 8.55003 2.0002 8.55003H12.6752L8.4252 12.875C8.2002 13.1 8.2002 13.45 8.4252 13.675C8.5252 13.775 8.6752 13.825 8.8252 13.825C8.9752 13.825 9.1252 13.775 9.2252 13.65L14.4002 8.40002C14.6252 8.17502 14.6252 7.82503 14.4002 7.60002Z" fill="white" />
              </svg>
            </Link> */}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
